<template>
  <div class="committee-contract-party-page figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('committeeContractParty.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-add" @click="handleAdd">
              <img src="../../../assets/CodeBuddyAssets/616_43635/29.svg" class="figma-btn-icon" />
              <span>{{ $t('committeeContractParty.action.add') }}</span>
            </el-button>
            <el-button size="small" class="figma-btn-refresh" :title="$t('committeeContractParty.action.refresh')" @click="getList">
              <img src="../../../assets/CodeBuddyAssets/616_43635/28.svg" class="figma-refresh-icon" />
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input v-model.trim="conditions.partyA" size="small" :placeholder="$t('committeeContractParty.search.partyA')" class="figma-search-input" clearable @keyup.enter.native="handleSearch" />
            <el-input v-model.trim="conditions.aContacts" size="small" :placeholder="$t('committeeContractParty.search.aContacts')" class="figma-search-input" clearable @keyup.enter.native="handleSearch" />
            <el-input v-model.trim="conditions.aLink" size="small" :placeholder="$t('committeeContractParty.search.aLink')" class="figma-search-input" clearable @keyup.enter.native="handleSearch" />
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <img src="../../../assets/CodeBuddyAssets/616_43635/33.svg" class="figma-search-icon" />
              <span>{{ $t('committeeContractParty.action.search') }}</span>
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :fit="true"
          :header-cell-style="headerCellStyle"
          :cell-style="cellStyle"
        >
          <el-table-column prop="communityName" :label="$t('committeeContractParty.table.communityName')" min-width="318" show-overflow-tooltip />
          <el-table-column prop="partyA" :label="$t('committeeContractParty.table.partyA')" min-width="300" show-overflow-tooltip />
          <el-table-column prop="aContacts" :label="$t('committeeContractParty.table.aContacts')" min-width="300" show-overflow-tooltip />
          <el-table-column prop="aLink" :label="$t('committeeContractParty.table.aLink')" min-width="512" show-overflow-tooltip />
          <el-table-column :label="$t('committeeContractParty.table.action')" min-width="150">
            <template slot-scope="scope">
              <div class="action-links">
                <a class="action-link" @click="handleEdit(scope.row)">{{ $t('committeeContractParty.action.edit') }}</a>
                <span class="link-space"></span>
                <a class="action-link" @click="handleDelete(scope.row)">{{ $t('committeeContractParty.action.delete') }}</a>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.row"
          layout="prev, pager, next"
          :total="pagination.total"
          @current-change="handlePageChange"
        />
        <el-select v-model="pagination.row" size="small" class="pagination-size-select" @change="handleSizeChange">
          <el-option label="10条/页" :value="10" />
          <el-option label="20条/页" :value="20" />
          <el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="650px"
      custom-class="contract-party-dialog"
      :close-on-click-modal="false"
      @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="form" :rules="formRules" label-width="120px" class="contract-party-form">
        <el-form-item :label="$t('committeeContractParty.form.community') + '：'" prop="communityId" required>
          <el-select v-model="form.communityId" filterable :placeholder="$t('committeeContractParty.form.communityPlaceholder')" style="width: 100%">
            <el-option v-for="item in myCommunities" :key="item.communityId" :label="item.name" :value="item.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('committeeContractParty.form.partyA') + '：'" prop="partyA" required>
          <el-input v-model.trim="form.partyA" :placeholder="$t('committeeContractParty.form.partyAPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('committeeContractParty.form.aContacts') + '：'" prop="aContacts" required>
          <el-input v-model.trim="form.aContacts" :placeholder="$t('committeeContractParty.form.aContactsPlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('committeeContractParty.form.aLink') + '：'" prop="aLink" required>
          <el-input v-model.trim="form.aLink" :placeholder="$t('committeeContractParty.form.aLinkPlaceholder')" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="contract-party-footer">
        <el-button class="contract-party-btn-cancel" @click="dialogVisible = false">{{ $t('committeeContractParty.dialog.cancel') }}</el-button>
        <el-button class="contract-party-btn-save" :loading="submitting" @click="submitForm">{{ $t('committeeContractParty.dialog.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { queryContractPartya, saveContractPartya, updateContractPartya, deleteContractPartya } from '@/api/contract/contractPartyaManageApi'

export default {
  name: 'CommitteeContractPartyList',
  data() {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      dialogMode: 'add',
      conditions: { partyA: '', aContacts: '', aLink: '' },
      tableData: [],
      myCommunities: [],
      pagination: { total: 0, page: 1, row: 10 },
      form: this.getDefaultForm(),
      formRules: {
        communityId: [{ required: true, message: this.$t('committeeContractParty.validate.community'), trigger: 'change' }],
        partyA: [
          { required: true, message: this.$t('committeeContractParty.validate.partyA'), trigger: 'blur' },
          { max: 200, message: this.$t('committeeContractParty.validate.partyAMaxLength'), trigger: 'blur' }
        ],
        aContacts: [
          { required: true, message: this.$t('committeeContractParty.validate.aContacts'), trigger: 'blur' },
          { max: 64, message: this.$t('committeeContractParty.validate.aContactsMaxLength'), trigger: 'blur' }
        ],
        aLink: [
          { required: true, message: this.$t('committeeContractParty.validate.aLink'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('committeeContractParty.validate.aLinkFormat'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.dialogMode === 'add' ? this.$t('committeeContractParty.dialog.addTitle') : this.$t('committeeContractParty.dialog.editTitle')
    }
  },
  created() { this.initPage() },
  methods: {
    getDefaultForm() {
      return { partyaId: '', communityId: '', partyA: '', aContacts: '', aLink: '' }
    },
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      const base = { color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', fontWeight: rowIndex % 2 === 1 ? '500' : '400' }
      return rowIndex % 2 === 1 ? { ...base, background: '#F8FBFF' } : { ...base, background: 'white' }
    },
    isSuccess(res) {
      return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success')
    },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      if (Array.isArray(res && res.rows)) return res.rows
      if (Array.isArray(res && res.contractPartyas)) return res.contractPartyas
      return []
    },
    getTotal(res, list) {
      return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0)
    },
    async initPage() {
      await this.loadCommunities()
      this.getList()
    },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.myCommunities = res.data || []
      } catch (e) {
        this.myCommunities = []
      }
    },
    getCommunityName(row) {
      if (row.communityName) return row.communityName
      const community = this.myCommunities.find(item => item.communityId === row.communityId)
      return community ? community.name : '-'
    },
    normalizeRow(row) {
      return {
        ...row,
        partyaId: row.partyaId || row.partyId || row.id,
        communityName: this.getCommunityName(row),
        partyA: row.partyA || row.partyName || '',
        aContacts: row.aContacts || row.contactPerson || '',
        aLink: row.aLink || row.contactTel || ''
      }
    },
    async getList() {
      try {
        this.loading = true
        const res = await queryContractPartya({
          page: this.pagination.page,
          row: this.pagination.row,
          partyA: this.conditions.partyA,
          aContacts: this.conditions.aContacts,
          aLink: this.conditions.aLink,
          partyName: this.conditions.partyA,
          contactPerson: this.conditions.aContacts,
          contactTel: this.conditions.aLink,
          communityIds: this.myCommunities.map(c => c.communityId).join(',')
        })
        const list = this.getListArray(res)
        this.tableData = list.map(item => this.normalizeRow(item))
        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error(this.$t('committeeContractParty.message.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    handleAdd() {
      this.dialogMode = 'add'
      this.form = this.getDefaultForm()
      let defaultCommunityId = getCommunityId()
      if ((!defaultCommunityId || defaultCommunityId === '-1') && this.myCommunities.length) {
        defaultCommunityId = this.myCommunities[0].communityId
      }
      this.form.communityId = defaultCommunityId
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogMode = 'edit'
      this.form = {
        partyaId: row.partyaId,
        communityId: row.communityId || getCommunityId(),
        partyA: row.partyA,
        aContacts: row.aContacts,
        aLink: row.aLink
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleDialogClosed() {
      if (this.$refs.form) this.$refs.form.resetFields()
    },
    async submitForm() {
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return
      try {
        this.submitting = true
        const payload = {
          ...this.form,
          partyName: this.form.partyA,
          contactPerson: this.form.aContacts,
          contactTel: this.form.aLink
        }
        const api = this.dialogMode === 'add' ? saveContractPartya : updateContractPartya
        const res = await api(payload)
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || this.$t('committeeContractParty.message.saveError'))
        this.$message.success(this.$t('committeeContractParty.message.saveSuccess'))
        this.dialogVisible = false
        this.getList()
      } catch (e) {
        this.$message.error(e.message || this.$t('committeeContractParty.message.saveError'))
      } finally {
        this.submitting = false
      }
    },
    handleDelete(row) {
      this.$confirm(this.$t('committeeContractParty.dialog.deleteConfirm'), this.$t('committeeContractParty.dialog.deleteTitle'), { type: 'warning' }).then(async () => {
        const res = await deleteContractPartya({ partyaId: row.partyaId, communityId: row.communityId || getCommunityId() })
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || this.$t('committeeContractParty.message.deleteError'))
        this.$message.success(this.$t('committeeContractParty.dialog.deleteSuccess'))
        this.getList()
      }).catch(e => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.committee-contract-party-page { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 12px; gap: 12px; flex-shrink: 0; }
.figma-page-title { font-size: 16px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; line-height: 22px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; align-items: center; gap: 12px; }
.figma-btn-add { width: 82px; height: 38px; min-height: 38px; padding: 0 !important; background: #0E76FF !important; border: none !important; color: white !important; border-radius: 10px !important; font-size: 14px; font-weight: 500; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-icon { width: 16px; height: 16px; margin-right: 6px; flex-shrink: 0; }
.figma-refresh-icon { width: 16px; height: 16px; }
.figma-search-icon { width: 16px; height: 16px; flex-shrink: 0; }
.figma-btn-refresh { width: 38px; height: 38px; min-height: 38px; padding: 0 !important; background: white !important; border: 1px solid #DCE6F5 !important; color: #6A7282 !important; border-radius: 10px !important; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-refresh:hover { border-color: #0E76FF !important; color: #0E76FF !important; }
.figma-search-group { display: flex; align-items: center; gap: 12px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input >>> .el-input__inner { height: 38px !important; line-height: 38px !important; border-radius: 10px; border: none; outline: 1px #DCE6F5 solid; outline-offset: -1px; color: #1D2129; font-size: 14px; background: white; }
.figma-search-input >>> .el-input__inner::placeholder { color: #8C9BB4; }
.figma-search-input >>> .el-input__inner:focus { outline-color: #0E76FF; }
.figma-btn-search { width: 84px; height: 38px; min-height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; padding: 0 !important; display: inline-flex; align-items: center; justify-content: center; gap: 6px; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-table-section { flex: 0 0 auto; min-height: 0; padding: 12px 24px 0; overflow: auto; }
.figma-table-section >>> .el-table { border-radius: 0; overflow: hidden; border: none; }
.figma-table-section >>> .el-table::before { display: none; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; padding: 0 !important; }
.figma-table-section >>> .el-table__body td { border: none !important; padding: 0 !important; }
.figma-table-section >>> .el-table .cell { height: 50px; line-height: 50px; padding-left: 24px; padding-right: 24px; }
.action-links { display: flex; align-items: center; justify-content: flex-start; white-space: nowrap; }
.action-link { color: #0E76FF; font-size: 14px; cursor: pointer; text-decoration: none; font-weight: inherit; }
.action-link:hover { opacity: 0.85; }
.link-space { width: 24px; display: inline-block; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; padding: 18px 22px 24px; gap: 8px; flex-shrink: 0; }
.pagination-total { font-size: 14px; color: #1D2129; margin-right: 0; line-height: 22px; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; padding: 0; }
.figma-pagination >>> .btn-prev,
.figma-pagination >>> .btn-next { width: 32px; height: 32px; min-width: 32px; border-radius: 2px; background: white; padding: 0; }
.figma-pagination >>> .el-pager li { min-width: 32px; height: 32px; line-height: 32px; border-radius: 8px; color: #1D2129; font-weight: 600; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; margin-left: 0; }
.pagination-size-select >>> .el-input__inner { height: 32px !important; line-height: 32px !important; border-radius: 8px; background: #F2F3F5; border: none; font-size: 14px; color: #1D2129; }

.committee-contract-party-page >>> .contract-party-dialog { border-radius: 12px; overflow: hidden; }
.committee-contract-party-page >>> .contract-party-dialog .el-dialog__header { height: 66px; box-sizing: border-box; padding: 22px 24px; background: #EBF2FA; border-bottom: 1px solid #DCE6F5; }
.committee-contract-party-page >>> .contract-party-dialog .el-dialog__title { font-size: 16px; color: #1D2129; font-weight: 600; }
.committee-contract-party-page >>> .contract-party-dialog .el-dialog__headerbtn { top: 22px; right: 24px; }
.committee-contract-party-page >>> .contract-party-dialog .el-dialog__body { padding: 24px 24px 8px; }
.committee-contract-party-page >>> .contract-party-dialog .el-dialog__footer { padding: 8px 24px 28px; display: flex; justify-content: flex-end; gap: 12px; }
.contract-party-form .el-form-item { margin-bottom: 20px; }
.contract-party-form .el-form-item:last-child { margin-bottom: 0; }
.contract-party-form >>> .el-form-item { display: flex; align-items: center; }
.contract-party-form >>> .el-form-item__label { font-size: 14px; font-weight: 500; color: #1D2129; line-height: 38px; height: 38px; float: none; flex-shrink: 0; }
.contract-party-form >>> .el-form-item__content { flex: 1; margin-left: 0 !important; line-height: 38px; }
.contract-party-form >>> .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before { color: #FB2C36; margin-right: 4px; }
.contract-party-form >>> .el-input__inner { height: 38px !important; line-height: 38px !important; border-radius: 10px; border: 1px solid #DCE6F5; font-size: 14px; color: #1D2129; }
.contract-party-form >>> .el-input__inner::placeholder { color: #8C9BB4; }
.contract-party-form >>> .el-input__inner:focus { border-color: #0E76FF; }
.contract-party-footer { display: flex; justify-content: flex-end; gap: 12px; }
.contract-party-btn-cancel { width: 98px; height: 38px; min-height: 38px; border-radius: 10px !important; color: #0E76FF !important; border-color: #0E76FF !important; background: white !important; padding: 0 !important; }
.contract-party-btn-save { width: 98px; height: 38px; min-height: 38px; border-radius: 10px !important; background: #0E76FF !important; color: white !important; border-color: #0E76FF !important; padding: 0 !important; }

@media (max-width: 1024px) {
  .figma-header-row { align-items: flex-start; gap: 12px; flex-direction: column; }
  .figma-search-group { width: 100%; margin-left: 0; flex-wrap: wrap; }
  .figma-search-input { width: min(256px, calc(100vw - 150px)); }
}
</style>

